import { ArtCard } from "@components/art_card/art_card";
import { ArtModal } from "@components/art_modal/art_modal";
import { ArtistRoster } from "@components/artist_roster/artist_roster";
import { BioBox } from "@components/bio_box/bio_box";
import { FlashMessage } from "@components/flash_messages/flash_message";
import { MarkdownEditor } from "@components/markdown_editor/markdown_editor";
import { StudioEventsForm } from "@components/studio_events/studio_event_form";
import { TestFlashMessage } from "@components/test_flash_message/TestFlashMessage";
import { ArtistExclusionIndexPage } from "@pages/admin/artist_exclusions";
import { ArtistExclusionCreatePage } from "@pages/admin/artist_exclusions/create";
import { ContentBlocksIndexPage } from "@pages/admin/content_blocks";
import { ContentBlocksEditPage } from "@pages/admin/content_blocks/edit_page";
import { ManagementPage } from "@pages/admin/management";
import { PalettePage } from "@pages/admin/palette";
import { PressItemIndexPage } from "@pages/admin/press_items";
import { PressItemCreatePage } from "@pages/admin/press_items/create";
import { PressItemUpdatePage } from "@pages/admin/press_items/update";
import { ArtistsPage } from "@pages/artists/index/artists_page";
import { ArtistPage } from "@pages/artists/show/artist_page";
import { HomePageArtists } from "@pages/home/artists/home_page_artists";
import { PressIndexPage } from "@pages/press";
import type { FC } from "react";

import { StudioEventsList } from "./studio_events_list/studio_events_list";

class UnregisteredComponentError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "UnregisteredComponentError";
  }
}

/**
this serves as the registry.  All react components
that will be mounted at their root should be included here.
**/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const reactComponents: Record<string, FC<any>> = {
  ArtCard,
  ArtistExclusionCreatePage,
  ArtistExclusionIndexPage,
  ArtistPage,
  ArtistRoster,
  ArtistsPage,
  ArtModal,
  BioBox,
  ContentBlocksEditPage,
  ContentBlocksIndexPage,
  FlashMessage,
  HomePageArtists,
  ManagementPage,
  MarkdownEditor,
  PalettePage,
  PressIndexPage,
  PressItemIndexPage,
  PressItemCreatePage,
  PressItemUpdatePage,
  StudioEventsForm,
  StudioEventsList,
  TestFlashMessage,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lookup = (componentName: string): FC<any> => {
  if (!(componentName in reactComponents)) {
    throw new UnregisteredComponentError(
      `Unable to find component ${componentName}.  Has it been registered in the reactComponents index?`,
    );
  }
  return reactComponents[componentName];
};
